import { render, staticRenderFns } from "./SplitTestEdit.vue?vue&type=template&id=58ebc0ef&"
import script from "./SplitTestEdit.vue?vue&type=script&lang=js&"
export * from "./SplitTestEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports